const INSTANCE_MANAGEMENT_ENV = 'uat'

export const isInstanceManagementEnabled =
  import.meta.env.VITE_PROJECT_TYPE_FIREBASE === INSTANCE_MANAGEMENT_ENV

export { INSTANCE_MANAGEMENT_ENV }
